var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BoostPortalParamsHandler } from '../helpers/BoostPortalParamsHandler';
import { CallbackStatus } from '../enums/CallbackStatus';
import { GenericReduxBindableMixin } from 'badphraim/redux/GenericReduxBindableMixin';
import { BoostPortalRootStore } from '../redux/BoostPortalRootStore';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { Callback } from '../enums/Callback';
export class BoostUrlController extends GenericReduxBindableMixin(class {
}, () => __awaiter(this, void 0, void 0, function* () { return BoostPortalRootStore.instance(); })) {
    constructor(host) {
        super();
        this.isVippsSetup = false;
        this.shortTerm = false;
        this.noDirectDebit = false;
        (this.host = host).addController(this);
        this.host = host;
    }
    hostConnected() {
        this.getParameterDataFromHistoryState();
    }
    getParameterDataFromHistoryState() {
        var _a, _b;
        const data = history.state;
        if (!data) {
            return;
        }
        if (data.invoiceId) {
            this.invoiceId = data.invoiceId;
        }
        if (data.vippsSetup === true) {
            this.isVippsSetup = true;
        }
        if (data.callback) {
            this.callback = data.callback;
        }
        if (data.netsStatus) {
            this.netsStatus = data.netsStatus;
        }
        if (data.centerShort) {
            this.centerShort = data.centerShort;
        }
        if (data.shortTerm) {
            this.shortTerm = data.shortTerm;
        }
        if (data.noDirectDebit) {
            this.noDirectDebit = data.noDirectDebit;
        }
        (_a = this.onHistoryStateChange) === null || _a === void 0 ? void 0 : _a.call(this);
        (_b = this.onCallbackChange) === null || _b === void 0 ? void 0 : _b.call(this);
        return data;
    }
    getParameterDataFromUrl(centerShortName) {
        var _a, _b;
        const callback = BoostPortalParamsHandler.getParameter('callback');
        const vippsSetup = BoostPortalParamsHandler.getParameter('vippsSetup');
        const netsStatus = BoostPortalParamsHandler.getParameter('success');
        const centerShort = BoostPortalParamsHandler.getParameter('centerShort');
        const invoiceId = BoostPortalParamsHandler.getParameter('invoiceId');
        const shortTerm = BoostPortalParamsHandler.getParameter('shortterm');
        const noDirectDebit = BoostPortalParamsHandler.getParameter('directdebit');
        const urlParameterData = {
            callback: '',
            vippsSetup: false,
            netsStatus: '',
            centerShort: centerShortName !== null && centerShortName !== void 0 ? centerShortName : '',
            invoiceId: 0,
            shortTerm: false,
            noDirectDebit: false,
        };
        if (invoiceId) {
            urlParameterData.invoiceId = parseInt(invoiceId);
            (_a = this.onInvoiceIdChange) === null || _a === void 0 ? void 0 : _a.call(this, urlParameterData.invoiceId);
        }
        if (vippsSetup === CallbackStatus.VIPPS) {
            urlParameterData.vippsSetup = true;
        }
        if (callback) {
            urlParameterData.callback = callback;
        }
        if (netsStatus) {
            urlParameterData.netsStatus = netsStatus;
        }
        if (centerShort) {
            urlParameterData.centerShort = centerShort;
        }
        if (shortTerm) {
            urlParameterData.shortTerm = shortTerm === 'true' ? true : false;
        }
        if (noDirectDebit) {
            urlParameterData.noDirectDebit = noDirectDebit === 'true' ? true : false;
        }
        (_b = this.onCallbackChange) === null || _b === void 0 ? void 0 : _b.call(this);
        return urlParameterData;
    }
    checkForDirectLink() {
        if (BoostPortalParamsHandler.hasParameters() &&
            BoostPortalParamsHandler.getParameter('membershipId') &&
            BoostPortalParamsHandler.getParameter('departmentId')) {
            this.dispatch(BoostPortalStore.Actions.SetIsDirectLink(true));
        }
        else {
            this.dispatch(BoostPortalStore.Actions.SetIsDirectLink(false));
        }
    }
    hideParametersInURL(urlParameterData) {
        return __awaiter(this, void 0, void 0, function* () {
            const membershipId = BoostPortalParamsHandler.getParameter('membershipId');
            const departmentId = BoostPortalParamsHandler.getParameter('departmentId');
            const isClassesView = location.pathname.includes('classes');
            const isPaymentStatusView = location.pathname.includes('betaling');
            if (!BoostPortalParamsHandler.hasParameters() || isPaymentStatusView) {
                return;
            }
            if (membershipId) {
                this.dispatch(BoostPortalStore.Actions.SetSelectedMembershipId(parseInt(membershipId)));
                if (!isClassesView) {
                    BoostPortalParamsHandler.removeParameter('membershipId');
                }
            }
            if (departmentId) {
                this.dispatch(BoostPortalStore.Actions.SetSelectedDepartmentId(parseInt(departmentId)));
                if (!isClassesView) {
                    BoostPortalParamsHandler.removeParameter('departmentId');
                }
            }
            if (isClassesView) {
                return;
            }
            history.replaceState(urlParameterData, urlParameterData.centerShort, window.location.pathname);
            const popstateEvent = new PopStateEvent('popstate', {
                state: urlParameterData,
                bubbles: true,
                composed: true,
            });
            window.dispatchEvent(popstateEvent);
        });
    }
    buildNetsCallbackUrl(shortTerm, noDirectDebit, centerShort) {
        if (!centerShort) {
            return window.location.origin;
        }
        const callbackUrl = new URL(`${window.location.origin}/${centerShort}/member`);
        callbackUrl.searchParams.set('callback', Callback.NETS);
        callbackUrl.searchParams.set('shortterm', shortTerm.toString());
        callbackUrl.searchParams.set('directdebit', noDirectDebit.toString());
        return callbackUrl.toString();
    }
}
